import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.ul`
  ${({ theme }) => css`
    width: 100%;
    max-height: inherit;
    padding: 4px 8px 4px 4px;
    overflow-y: auto;
    border-radius: 8px;
    background: ${theme.backgroundColor.elevated};
    ${theme.mixins.scroll.dropdown};
  `}
`;

export const Option = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    width: 100%;
    height: 44px;
    padding-left: 16px;
    border-radius: 8px;
    ${theme.fontStyle.text.body16_medium}
    color: ${theme.content.hierarchy1};

    &:hover {
      background: ${theme.backgroundColor.onelevated};
    }

    &:disabled {
      background: none;
      color: ${theme.content.btn_disabled};
      cursor: not-allowed;
    }
  `}
`;
